/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyholderDetails: {
        id: 'cep.accountPage.PolicyholderDetails',
        defaultMessage: 'Policyholder Details'
    },
    NoAccountMessage: {
        id: 'cep.accountPage.NoAccountMeggase',
        defaultMessage: 'Sorry, for security reasons we are unable to show you the policyholder\'s details. The policyholder can access them by logging into MySaga with the email address they used when they bought the policy.'
    },
    IfYouArePolicyholder: {
        id: 'cep.accountPage.IfYouArePolicyholder',
        defaultMessage: 'If you are the policyholder and still can\'t access your details, please contact us via '
    },
    WebChatLink: {
        id: 'cep.accountPage.WebChatLink',
        defaultMessage: 'web chat.'
    },
    Logout: {
        id: 'cep.accountPage.Logout',
        defaultMessage: 'Logout'
    }
});
